import { APICore } from "./apiCore";

const api = new APICore();

// course
function addTestimonial(params: {
  rating: string;
  comment_en: string;
  comment_ar: string;
  user_name: string;
  user_name_ar: string;
  courseId: string;
}) {
  const baseUrl = "/testimonial";
  return api.create(`${baseUrl}`, params);
}

function getTestimonial() {
  const baseUrl = "/testimonial";
  return api.get(`${baseUrl}`, {});
}

function updateTestimonial(
  id: number,
  params: {
    rating: string;
    comment_en: string;
    comment_ar: string;
    user_name: string;
    user_name_ar: string;
    courseId: string;
  }
) {
  

  const baseUrl = `/testimonial/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deleteTestimonial(id: number) {
  const baseUrl = `/testimonial/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addTestimonial, deleteTestimonial, getTestimonial, updateTestimonial };
